{
  "longPressMessage": "اضغط مطولاً لفتح المعاينة"
}
